import { CreateButton, FilterButton, TopToolbar } from 'react-admin'

const DraftListActions = () => {
  return (
    <TopToolbar>
      <FilterButton />
      <CreateButton variant='contained' color='success' />
    </TopToolbar>
  )
}

export default DraftListActions